<template>
  <div class="main">
    <topImg :title="' '" desc="职业教育示范性虚拟仿真实训基地项目建设说明" img="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/b5615c697243ddf01b6803d67017f8ac.png
"></topImg>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="callback">
        <el-tab-pane label="政策解读" :name="1">
          <div class="desc">
            <p>7月教育部印发《关于加快推进现代职业教育体系建设改革重点任务的通知》，提出11项重点任务，其中包括建设职业教育示范性虚拟仿真实训基地，提出到2025年建成200个左右全国示范性虚仿基地，带动各地1000个左右区域示范性虚仿基地建设推动职业院校技术技能人才实训教学模式创新。</p>
            <p>文件同时明确了推进机制，指出各重点任务建设指南将在现代职业教育体系改革管理公共信息服务平台（网址：<a href="http://zj.chinaafse.cn/">http://zj.chinaafse.cn/</a>，以下简称管理平台）予以公布。教育部通过管理平台对各地重点任务建设情况进行过程管理。</p>
            <p>近日，管理平台公布了《职业教育示范性虚拟仿真实训基地项目建设说明》，对建设单位、基础条件、建设任务、监测指标、组织实施、时间安排做了详细部署。</p>
          </div>
          <div class="importance">
            <div>
              <div class="headline">虚拟仿真对职业教育的重要性</div>
              <div class="content">
                <div class="left">
                  <div class="title"> 职业教育虚拟仿真实训基地对职业教育有多重要？</div>
                  <div class="desc">
                    职业教育是国民教育体系和人力资源开发的重要组成部分。兼具职业性、社会性、教育性等多重属性的职业教育，其适应性发展本就是一个复杂系统问题。在现代化的背景下，职业教育适应性的内涵不断丰富，它是一个复杂系统问题，但归根到底，这种适应性是以职业教育的根本属性——服务经济社会发展与服务人的全面发展为宗旨。而职业教育虚拟仿真实训基地则是建设高质量现代化职业教育，加速高素质技能人才培养，为经济社会建设发展打好坚实基础的重要力量。
                  </div>
                </div>
                <img
                  src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/eeeda0c1c51bc34c65ac746b06cd6cd6.png"
                  alt=""
                  class="right"
                />
              </div>
            </div>
          </div>
          <div class="significance">
            <div class="title">
              职业教育虚拟仿真实训基地的意义
            </div>
            <div class="desc">
              <p>职业教育虚拟仿真实训基地具有情境性、交互性、开放性、共享性，三大特征，对深化现代职业教育思想、提高
                职业教育教学效率、提升教师的科技素养产生重要作用。</p>
              <p>通过职业教育虚拟仿真实训基地，借助虚拟仿真技术，从学生已掌握的专业理论知识和实践操作技能出发，合理
                选择教学内容、教学方法和教学手段，将抽象的问题或原理具体化，让学生能够熟练地掌握各项实践操作技能。在
                强化实践性的同时，又以实践来巩固理论，达到专业理论知识与实践技能水平一体化提升的教学目标。</p>
              <p>为了响应国家关于职业教育示范性虚拟仿真实训基地建设等方面的政策指导，格如灵针对智能制造、生物制药、
                畜牧兽医、能源化工、艺术体育等多专业提供虚仿（实验）实训基地建设、元宇宙远程教育实训平台、
                虚拟教研室等于一体的全栈解决方案，旨在为高职高校提供一站式的虚拟仿真实训教学服务。坚持“一校一策”，支
                持校校联合、校企共建。在虚拟仿真实训基地硬件设施的基础上，引入元宇宙、大数据等新一代信息技术，建设集
                教学、实训、考核、认知等功能于一体的综合性实训基地解决方案。</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="建设说明" :name="2">
          <div class="illustrate">
            <div class="list" v-for="item in illustrateList" :key="item.id">
              <div class="head">
                <img class="icon" :src="item.icon" alt="">
                <span>{{item.title}}</span>
              </div>
              <div class="desc">
                <p v-for="(it, index) in item.desc" :key="index" v-html="it"></p>
              </div>
            </div>
            <div class="list last">
              <div class="head">
                <img class="icon" :src="require('./assets/icon_6.png')" alt="">
                <span>时间安排</span>
              </div>
              <div class="desc">
                <p>
                  <span class="">注册填报时间：</span>
                  2023年8月11日—8月31日；2024年以后每年的1月1日—8月31日。
                  <span>(截止时间前省级教育行政部门需在管理平台完成审核程序并确认提交)</span></p>
                <p>
                  <span>绩效数据采集时间：</span>
                  2023年起每年11月1日—12月15日。
                  <span>(建设单位应及时登录管理平台查看有关通知)</span></p>
                <p>
                  <img :src="require('./assets/icon_wd.png')" alt="" srcset="">
                  <span @click="downloadFile">职业教育示范性虚拟仿真实训基地建设任务书任务书.docx</span>
                  <span class="button" @click="downloadFile">下载</span></p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="常见问题" :name="3">
          <div class="issue">
            <div class="title">职业教育示范性虚拟仿真实训基地建设常见问题解答</div>
            <div class="list" v-for="item in issueList" :key="item.id">
              <div class="head">
                <img class="icon" :src="item.icon" alt="">
                <span>{{item.title}}</span>
              </div>
              <div class="desc">
                <p v-for="(it, index) in item.desc" :key="index" v-html="it"></p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="部分项目案例" :name="4">
          <div class="case">
            <div class="caseLine">
              <div class="line"></div>
            </div>
            <div class="list">
              <div class="example" v-for="(item, index) in caseList" :key="index"  :class="index === 0 ? 'firstExample' : ''" >
                <div class="circle"><span></span></div>
                <div class="cantain">
                  <div class="year">{{item.title}}</div>
                  <div class="line"></div>
                  <div class="desc" v-html="item.desc"></div>
                  <div class="certImgArr" >
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue';
// import { Pagination } from 'vant';
// import { newsList } from '@/services/api'

// Vue.use(Pagination);

export default {
  data() {
    return {
      activeName: 1,
      illustrateList: [
        {
          id: 1,
          title: '建设单位',
          icon: require('./assets/icon_1.png'),
          desc: [
            '职业教育示范性虚拟仿真实训基地（以下简称虚仿基地）的建设单位为独立设置的职业学校（含中等职业学校、高职专科学校、本科层次职业学校）。'
          ]
        },
        {
          id: 2,
          title: '基础条件',
          icon: require('./assets/icon_2.png'),
          desc: [
            '1. 具备较好的实训条件。拥有较为充足的实训场地和一定规模的虚拟仿真实训资源、设施设备，能满足虚仿实训教学实施需要。',
            '2. 具备较强的教学科研团队。教学科研团队熟悉生产一线岗位实际需求，能将虚拟仿真等信息技术有效应用于教学全过程。',
            '3. 具备良好的虚仿技术应用基础。已在实训课程中开展虚仿教学改革探索，面向学生开展了一学期以上的虚拟仿真实训教学，且效果较好。',
            '4. 具备规范的管理运行机制。有丰富的项目管理经验，相关工作机制健全，能合理规划虚仿基地建设，并提供充分的政策和资金保障。'
          ]
        },
        {
          id: 3,
          title: '建设单位',
          icon: require('./assets/icon_3.png'),
          desc: [
            '<p style="text-indent: 2em;">虚仿基地以学校为基本单元开展建设，布局可集中、可分散，服务一个或多个专业（群），旨在通过虚拟现实、人工智能、数字孪生、物联网、大数据等新一代信息技术解决实训教学过程中的“三高三难”问题，提高专业实训教学质量。</p>',
            '1. 加强虚拟仿真实训基础设施建设。对现有实训教学场所进行功能升级、环境改造，因地制宜建设与实际岗位操作情景对接的虚拟仿真实训教学场所，配备实训教学必需的设施设备。建设虚仿实训教学管理及资源共享平台，提供资源承载、共享、使用服务，与校本大数据中心对接，实现数据采集、互联互通。',
            '2. 开发虚拟仿真教学资源。应用虚拟现实、人工智能、数字孪生、物联网、大数据等信息技术自主开发或校企合作开发各类虚拟仿真实训资源。资源建设与使用应与实际岗位技能和操作标准流程对接、与专业人才培养方案和职业培训方案对接、与实习实训对接，覆盖专业核心课程实训教学中“三高三难”关键技能点，三年年均更新率不低于10%。提倡建设单位自主开发拥有完全自主知识产权的虚拟仿真实训资源。',
            '3. 推动专业实训课程创新与重构。校企合作推动虚仿技术与专业实训教学有机融合，共同丰富教学内容、拓展实践领域，建设虚仿实训课程，修订实训课程标准、实训指导书、教学评价标准等。开展虚仿环境下的实训教学方法改革，创新自主学习、探究学习、协作学习等模式，提升实训教学质量，重构虚实结合的实训新生态。',
            '4. 打造虚拟仿真实训教学科研团队。校企合作组建专兼结合、信息素养高的虚拟仿真实训教学科研团队（以下简称团队）。开展虚拟现实、人工智能、数字孪生、物联网、大数据等信息技术应用和教学能力、技术技能提升培训，增强团队的信息化素养和教科研能力。建立健全激励机制，引导团队围绕数字化转型、真实生产和实训教学需要，开展纵横向课题研究。',
            '5. 构建共建共享共用机制。根据区域重点产业数字化转型需求，以院校为主导，探索校校合作、校企合作、校地合作共建虚仿基地。推动虚仿资源接入国家或省级职业教育智慧教育平台，实现更大范围资源共享。充分利用虚仿基地资源，面向社会开展岗位培训、继续教育、科普、竞赛等服务，扩大虚仿基地影响力。'
          ]
        },
        {
          id: 4,
          title: '监测指标',
          icon: require('./assets/icon_4.png'),
          desc: [
            '主要监测指标包括<span style="font-weight: bold;">建设情况、应用情况、示范特色</span>三大类。',
            '1. 建设情况主要考核项目建设资金执行（含预算支出执行率等）、管理平台建设（含管理平台规范建设情况等）、虚仿教学资源开发（含资源更新率等）、虚拟仿真实训教学科研团队建设情况（含参加虚拟仿真教学专题培训等）和建设成效（含任务完成度等）五项。',
            '2. 应用情况主要考核人才培养成效（含结合虚拟仿真技术优化专业人才培养方案、虚仿基地服务学生考取技能证书情况等）、社会服务成效（含利用虚仿基地开展社会培训成效等）课程共享使用（含虚拟仿真课程开放共享服务人数等）三项。',
            '3. 示范特色为自选指标，主要考核各建设单位典型经验和成效。'
          ]
        },
        {
          id: 5,
          title: '组织实施',
          icon: require('./assets/icon_5.png'),
          desc: [
            '建设单位对照虚仿基地基础条件、建设任务，在“现代职业教育体系改革管理公共信息服务平台”（网址：<a style="color: #0054FF" href="http://zj.chinaafse.cn/">http://zj.chinaafse.cn/</a>，以下简称“管理平台”）进行账号注册，并在“职业教育示范性虚拟仿真实训基地”模块填写信息数据、上传相关佐证材料，形成《职业教育示范性虚拟仿真实训基地建设任务书》（详见附件），报省级教育行政部门审核同意后，将加盖建设单位和省级教育行政部门公章的《建设任务书》PDF版通过管理平台上传，无需寄送纸质版。',
            '省级教育行政部门要组织省内职业院校积极参与，按照指南要求对项目进行审核把关，对符合要求的项目加盖公章，待学校上传PDF版后登录管理平台完成审核程序并提交至教育部职业教育与成人教育司。',
            '215个国家级职业教育示范性虚拟仿真实训基地培育项目和已纳入教育部高等学校科学研究发展中心监测范围的211个省级职业教育示范性虚拟仿真实训基地项目按照本次建设要求重新填报任务书。'
          ]
        }
      ],
      issueList: [
        {
          id: 1,
          title: '职业教育示范性虚拟仿真实训基地（以下简称虚仿基地）建设的目标要求是什么？',
          icon: require('./assets/icon_q1.png'),
          desc: [
            '虚仿基地建设旨在通过虚拟现实、人工智能、数字孪生、物联网、大数据等新一代信息技术解决实训教学过程中的“三高三难”问题，提高专业实训教学质量。',
            '有基础、有意愿、独立设置且符合条件的职业学校（含中等职业学校、高职专科学校、本科层次职业学校）均可根据实际需要自主开展项目建设。项目建设应与行业企业生产实际需求相结合，坚持科技引领、虚实结合，育训并举、教学创新，一校一策、共建共享，科学管理、规范考核，有效服务一个或多个专业（群）的人才培养或社会培训需要。'
          ]
        },
        {
          id: 2,
          title: '虚仿基地建设结果怎么确定？',
          icon: require('./assets/icon_q2.png'),
          desc: [
            '虚仿基地建设结果将通过过程性评价的方式产生。过程性评价的开展主要基于日常绩效数据采集。教育部职成司将围绕虚仿基地建设五项任务要求设计监测指标，综合考虑前期建设基础、绩效采集数据、应用成效等，对各建设项目的总体情况进行考核，通过适当方式公布考核排名，强化结果运用。'
          ]
        },
        {
          id: 3,
          title: '2021年教育部职成司启动的虚仿基地培育项目如何开展新一轮建设？',
          icon: require('./assets/icon_q3.png'),
          desc: [
            '2021年教育部职成司启动虚仿基地项目培育工作，并委托教育部高等学校科学研究发展中心开展虚仿基地建设指导与监测，定期采集绩效数据。部分省（区、市）也同步开展了省级虚仿基地建设。',
            '截至目前，共监测虚仿基地项目426个（包括215个国家级培育项目和211个省级项目）。',
            '新一轮虚仿基地建设将延续前期工作，已纳入监测范围的426个项目应按照本次建设要求重新填报任务书，按照统一标准接受监测。',
            '效采集于每年11月1日-12月15日进行，各建设单位应及时登录管理平台查看有关通知。'
          ]
        },
        {
          id: 4,
          title: '虚仿基地建设是否需要集中在一个固定场所开展？',
          icon: require('./assets/icon_q4.png'),
          desc: [
            '学校应按照不同专业实训需求布局虚仿实训场所，可分散、可集中，公用虚仿实训设备可集中布置管理，专业虚仿实训设备可在不同专业实训场所分散部署。'
          ]
        },
        {
          id: 5,
          title: '虚仿基地什么时间进行注册填报和绩效数据采集？',
          icon: require('./assets/icon_q5.png'),
          desc: [
            '虚仿基地依托管理平台进行注册和绩效数据采集。',
            '其中，注册填报时间为2023年8月11日-8月31日和2024年起每年的1月1日至8月31日，在此期间，各虚仿基地建设单位均可在管理平台进行注册填报，绩效数据采集时间为2023年起每年的11月1日-12月15日，期间管理平台将关闭注册填报功能，开启年度绩效数据采集功能。'
          ]
        }
      ],
      caseList: [
        {
          title: '辽宁农业职业学院畜牧专业国家级虚拟仿真基地',
          desc: `为提高畜牧专业的教学质量和效果，促进学生的实践能力和创新能力的培养，格如灵科技与辽宁农业职业学院畜牧
            专业国家级虚拟仿真基地虚拟仿真实训室项目落地。畜牧业虚拟仿真实训室包括畜牧机械（鸡场）虚拟仿真实训、虚拟动
            物医院教学实训、执业兽医系列化课程、饲料厂生产流程虚拟仿真实训、动物防疫技能大赛虚拟仿真实训系统、不同种类
            寄生虫结构与组装、寄生虫卵结构与组装、兽医岗位关键技能虚拟仿真实训，身临其境，完全体验式学习，提升了学生对
            畜牧兽医专业课程的学习兴趣和学习效果。`,
          img: require('./assets/pic_1.png'),
        },
        {
          title: '浙江旅游职业学院国家级虚拟仿真基地',
          desc: `<p>在旅游教学体系完整建立的基础上，构建综合实训旅游教学实验室。通过XR技术与实景实物系统开发相结合的
            方式，为实训系统提供完整的场境。旅游体系与实训体系实现相辅相成，相互补充促进的模式。</p>
            <p>旅游XR实训教学区适用于旅游教学培训考试，通过环幕、高清设备等展示手段，逼真再现旅游景点，丰富教学手段，
                成为旅游实训的发展趋势。</p>`,
          img: require('./assets/pic_2.png'),
        },
        {
          title: '南通市海门中等专业学校虚拟仿真实训基地',
          desc: `建设该校的VR虚拟仿真实训中心，本公司将该校的VR虚拟仿真实训中心设计成为6个区域，分别是教学展示区、
          教学实训区、MR交互体验区、VR实训体验区、交流讨论区、文化氛围实施部分。`,
          img: require('./assets/pic_3.png'),
        },
        {
          title: '衢州职业技术学院医疗康养虚拟仿真实训基地',
          desc: `衢州职业技术学院医学院虚拟仿真实训基地建设，共设计3个展示区域：虚拟仿真体验中心（公共区）、桌面式
            VR教学实训室、VR交互大屏教学实训室。学生通过3D主动立体眼镜进行沉浸式观摩学习，并可以通过互动完成实训课程，
            通过虚拟与实操结合，使教学环境更加具有实践意义。`,
          img: require('./assets/pic_4.png'),
        },
        {
          title: '安徽商贸职业技术学院国家级虚拟仿真示范基地',
          desc: `本项目结合安徽商贸职业技术学院实际需求，满足3D虚拟仿真交互及大屏教学的需要。采用LED大屏，光学动捕
            系统，交互手柄搭建LED-3D交互系统虚拟仿真环境，可满足学校日常教学，3D影片播放，并可通过光学动捕系统实现
            3D教学资源交互。为学院改善教学环境，增加教学方式提供硬件系统支撑。`,
          img: require('./assets/pic_5.png'),
        },
      ]
    };
  },
  created() {
  },
  methods: {
    // 下载文件
    downloadFile() {
      window.open('https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/b49520978363e82f1c8a805b0c145e5c.docx');
    },
  }
};
</script>
<style lang="less" scoped>
#pageChange{
  position: relative;
  top: -80px;
}
/deep/.banner .cover > div .desc{
  margin-top: 50px;
  margin-left: 50px;
}
.main {
  background: #fff;
  .container{
    // width: 1200px;
    // margin: 0 auto;
    /deep/.el-tabs__nav-wrap::after{
      height: 1px;
      background: #EBECED;
    }
    /deep/.el-tabs__nav-scroll{
      width: 1200px;
      margin: 0 auto;
      .el-tabs__nav{
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .el-tabs__item{
        height: auto;
        font-size: 18px;
        font-weight: 500;
        color: #202122;
        line-height: 25px;
        padding: 23px 62px;
      }
      .el-tabs__item.is-active{
        font-size: 18px;
        font-weight: 500;
        color: #F27529;
        line-height: 25px;
        display: flex;
        justify-content: center;
        position: relative;
        &::after{
          content: '';
          width: 60px;
          height: 3px;
          bottom: -1px;
          border-radius: 10px;
          position: absolute;
          background: #F27529;
        }
      }
    }
    /deep/.el-tabs__content{
      padding: 53px 0 68px;
      .desc{
        width: 1200px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        text-indent: 2em;
        letter-spacing: 2px;
        margin: 0 auto 70px;
        a{
          color: #0054FF;
        }
      }
      .importance{
        padding-top: 62px;
        width: 100%;
        background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_shouqian.png);
        background-size: 100% 100%;
        > div {
          width: 1200px;
          height: 100%;
          margin: 0 auto;
          .headline {
            font-size: 28px;
            font-weight: 600;
            color: #000000;
            line-height: 40px;
            text-align: center;
            letter-spacing: 2px;
          }
          .content {
            padding-top: 44px;
            display: flex;
            justify-content: space-between;
            .left {
              width: 700px;
              padding-top: 32px;
                .title {
                  font-size: 18px;
                  font-weight: 600;
                  color: #F27529;
                  line-height: 48px;
                  display: block;
                  margin-bottom: 20px;
                }
              .desc{
                width: 100%;
                margin-bottom: 0;
                letter-spacing: 2px;
              }
            }
            .right {
              width: 463px;
              height: 446px;
            }
          }
        }
      }
      .significance{
        padding-top: 70px;
        .title{
          width: 1200px;
          margin: 0 auto;
          text-align: center;
          font-size: 28px;
          font-weight: 600;
          color: #000000;
          line-height: 40px;
          margin-bottom: 30px;
          letter-spacing: 2px;
        }
      }
      .issue,
      .illustrate{
        width: 1200px;
        margin: 0 auto;
        .title {
          font-size: 18px;
          font-weight: 600;
          color: #000000;
          line-height: 48px;
          text-align: center;
          letter-spacing: 2px;
        }
        .list{
          margin-top: 30px;
          .head{
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            height: 25px;
            .icon{
              width: 30px;
              height: 30px;
              margin-right: 20px;
            }
            >span{
              display: inline-block;
              height: 25px;
              line-height: 25px;
              font-weight: bold;
              font-size: 16px;
            }
          }
          .desc{
            padding: 20px 50px 0 50px;
            margin-left: 45px;
            text-indent: 0;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 29px;
            margin-bottom: 30px;
            background-color: #F7FAFC;
            p{
              text-indent: 0;
              span{
                font-size: 16px;
              }
            }
          }
          .desc:last-child{
            padding-bottom: 20px;
          }
        }
        .list.last{
          .desc p:not(:last-child){
            span:first-child{
              font-weight: bold;
            }
            span:last-child{
              color: #5B6679;
            }
          }
          .desc p:last-child{
            img{
              width: 12px;
              margin-right: 6px;
              top: 3px;
              position: relative;
            }
            span{
              line-height: 20px;
              padding-bottom: 3px;
              color: #184FAE;
              cursor: pointer;
              display: inline-block;
              border-bottom: 1px solid #184FAE;
            }
            span:last-child{
              font-size: 14px;
              color: #0061FF;
              margin-left: 22px;
              border-bottom: 0;
            }
          }
        }
      }
      .case{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .caseLine{
          width: 3px;
          height: 1580px;
          .line{
            width: 2px;
            height: 100%;
            background: url('./assets/bj_shijian_xian.png') no-repeat;
            background-size: 100% 100%;
            // background-color: #c9d5e2;
          }
        }
        .list{
          left: -14px;
          .example{
            display: flex;
            flex-direction: row;
            justify-content: start;
            .circle{
              width: 10px;
              min-height: 10px;
              margin:0 30px 320px 0;
              span{
                width: 10px;
                height: 10px;
                display: inline-block;
                border-radius: 14px;
                left: -6px;
                top: -10px;
                background-image: radial-gradient(#C9D5E3, #A2B8CC);
                position: relative;
              }
            }
            .cantain{
              display: flex;
              flex-direction: column;
              .year{
                color: #000000;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
              }
              .line{
                width: 27px;
                height: 4px;
                background-color: #EF623D;
                border-radius: 2px;
                margin-bottom: 12px;
              }
              .desc{
                font-size: 14px;
                line-height: 29px;
                margin-bottom: 8px;
                text-indent: 0;
              }
              .certImgArr{
                width: 100%;
                margin-bottom: 60px;
                img{
                  height: 150px;
                }
              }
            }
          }
          .firstExample{
            margin-top: 61px;
          }
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main {
    .container {
      /deep/ .el-tabs__nav-scroll .el-tabs__item.is-active {
        font-size: 26px;
      }
      /deep/.el-tabs__nav-scroll {
        width: 100%;
        .el-tabs__nav {
          flex-wrap: wrap;
        }
        .el-tabs__item {
          font-size: 26px;
          padding: 16px 30px;
          height: auto;
        }
      }
      /deep/.el-tabs__content {
        padding: 40px 48px;
        .desc {
          width: 100%;
          font-size: 26px;
          line-height: 44px;
          margin-bottom: 40px;
        }
        .importance {
          padding-top: 40px;
          > div {
            width: 100%;
            .headline {
              font-size: 32px;
            }
            .content {
              flex-direction: column;
              .left {
                width: 100%;
                padding-top: 20px;
                .title {
                  font-size: 30px;
                }
                .desc {
                  font-size: 26px;
                  margin-bottom: 20px;
                }
              }
              .right {
                width: 100%;
                height: auto;
                margin-top: 30px;
              }
            }
          }
        }
        .significance {
          padding-top: 40px;
          .title {
            width: 100%;
            font-size: 32px;
            margin-bottom: 20px;
          }
        }
        .illustrate,
        .issue {
          width: 100%;
          .title {
            font-size: 28px;
          }
          .list {
            margin-top: 20px;
            .head {
              height: auto;
              .icon {
                width: 36px;
                height: 36px;
              }
              > span {
                font-size: 28px;
                height: auto;
                line-height: 1.5;
              }
            }
            .desc {
              margin-left: 0;
              padding: 20px 30px;
              font-size: 24px;
              line-height: 40px;
            }
          }
        }
        .case {
          width: 100%;
          .caseLine {
            height: auto;
            min-height: 100%;
          }
          .list {
            .example {
              .circle {
                margin: 0 20px 200px 0;
              }
              .cantain {
                .year {
                  font-size: 28px;
                }
                .desc {
                  font-size: 24px;
                  line-height: 40px;
                }
                .certImgArr {
                  img {
                    height: auto;
                    width: 100%;
                    max-width: 600px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
